import styled from 'styled-components';
import { Button } from 'ui-components/src/components/atoms/Button';
import { Modal } from 'ui-components/src/components/atoms/Modal';
import { MultiSelect } from 'ui-components/src/components/atoms/Select/Multi';
import {
  Options,
  Option,
} from 'ui-components/src/components/atoms/Select/Multi/styles';

export const StyledModal = styled(Modal)`
  width: 35rem;
  position: relative;
`;

export const Form = styled.form`
  display: grid;
  grid-gap: 1rem;
  margin-bottom: 1rem;
`;

export const Notice = styled.p`
  line-height: 1.5;
  color: gray;
`;

export const ButtonBar = styled.div`
  display: flex;
  align-items: center;
  padding: 0 0.5rem 0 0.5rem;
`;

export const StyledButton = styled(Button)`
  min-width: 7rem;
  margin-right: 1rem;
`;

export const SectionTitle = styled.h5`
  margin: 0;
  font-size: 1rem;
`;

export const AttachmentsBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightGrey};
  padding-bottom: 0.5rem;
`;

export const InputMessage = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textGrey};
  margin: 0;
  padding: 16px 0;
`;

export const AttachmentUploadModalWrapper = styled.div`
  position: absolute;
  top: 3rem;
  left: 0;
  height: calc(100% - 3rem);
  width: 100%;
  padding: 0.5rem 1.5rem;
  background-color: #fff;
  z-index: 10;
`;

export const ErrorMessage = styled.p`
  font-size: 14px;
  margin: 0;
  color: ${({ theme }) => theme.colors.secondary.red};
`;

export const MessageWrapper = styled.div`
  margin: 0.5rem 12px 0 12px;
  height: 1rem;
`;

export const StyledMultiSelect = styled(MultiSelect)`
  ${Options} {
    max-height: 21rem;
  }
  ${Option} {
    .checkbox {
      // is used to override the default padding
      padding: 0.5rem 0;
    }
  }
`;
